/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */
import React from "react"
import PropTypes from "prop-types"
import "../scss/index.scss"
import { TransitionState } from "gatsby-plugin-transition-link"

const Layout = ({ children, width }) => {
  return (
    <TransitionState
      className="overflow-hidden"
      exit={{ length: width > 640 ? 1 : 0 }}
    >
      {({ mount, exit }) => {
        const pageProps = () => {
          const props = {
            className:
              width > 640
                ? exit.length
                  ? mount
                    ? "show-layout"
                    : "hide-layout"
                  : ""
                : !mount
                ? "mobile-layout opacity-0"
                : "",
          }
          if (!props.className) delete props.className
          return props
        }
        return (
          <div {...pageProps()}>
            <main>{children}</main>
          </div>
        )
      }}
    </TransitionState>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  width: PropTypes.number,
}

export default Layout
